"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHAPTER_7 = exports.BANKRUPTCY = void 0; // Legal Context Types

var BANKRUPTCY = 'bankruptcy';
exports.BANKRUPTCY = BANKRUPTCY;
var CHAPTER_7 = 'chapter7';
exports.CHAPTER_7 = CHAPTER_7;